<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            <h1>เปลี่ยนรหัสผ่าน</h1>
          </div>
          <form role="form">
            <base-input
              class="input-group-alternative mb-3"
              type="password"
              name="password"
              placeholder="รหัสผ่าน"
              addon-left-icon="ni ni-key-25"
              v-model="password"
            >
              <!-- v-on:blur="checkpassword()"> -->
            </base-input>
            <base-input
              class="input-group-alternative mb-3"
              type="password"
              name="re-password"
              placeholder="รหัสผ่านอีกครั้ง"
              addon-left-icon="ni ni-key-25"
              v-model="re_password"
            >
              <!-- v-on:blur="checkpassword()"> -->
            </base-input>

            <div class="text-center">
              <base-button
                type="submit"
                class="my-4 btn btn-primary"
                v-on:click="submitpassword()"
                >Send</base-button
              >
              <!-- <button type="submit" name="button">เข้าสู่ระบบ</button> -->
            </div>
          </form>
          <div
            v-if="alert_success.status == true"
            class="alert alert-success"
            role="alert"
          >
            {{ alert_success.text }} !!!
          </div>
          <div
            v-if="alert_danger.status == true"
            class="alert alert-warning"
            role="alert"
            style="text-align: center"
          >
            <b> {{ alert_danger.text }} !!!</b>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <!-- <div class="col-6">
                    <a href="#" class="text-light"><small>ลืมรหัสผ่าน?</small></a>
                </div> -->
        <!-- <div class="col-6 text-right">
                    <router-link to="/register" class="text-light"><small>สร้างบัญชีใหม่</small></router-link>
                </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import JwService from "../service/justwash";

export default {
  name: "changepassword",
  data() {
    return {
      password: '',
      re_password: '',
      alert_success:{
        status: false,
        text: "",
      },
      alert_danger: {
        status: false,
        text: "",
      },
      token: '',
    };
  },
async mounted() {
  this.token = this.$route.params.token;
},
  methods: {
    submitpassword: async function () {
        this.alert_success.status = false;
        this.alert_danger.status = false;
        // console.log('this.password' ,this.password);
        // console.log('this.re_password', this.re_password);
      if (this.password !== '' && this.re_password !== '') {
      
          let has_number = /\d/.test(this.password);
          let has_lowercase = /[a-z]/.test(this.password);
          let has_uppercase = /[A-Z]/.test(this.password);
          let has_special = /[;:?><{},()"ๆ'!@#\$%\^\&*\)\(+=.-]/.test(this.password);

          if ((has_number == true || has_lowercase == true || has_uppercase == true) &&  has_special == false) {
           this.alert_danger.status = false;

            if (this.password == this.re_password) {
              // eslint-disable-next-line no-undef
              await axios({
              method: "post",
              url: JwService.getAPI()+ "/api/method/justwash.OwnerApi.reset_password",
              data: {token: this.token, password: window.btoa(this.password)},
            })
              .then((response) => {
                  if (response.data.message.status == true) {
                     this.alert_success.status = true;
                     this.alert_success.text =  response.data.message.message;
                     alert('อัพเดทรหัสผ่านเรียบร้อยแล้ว'); 
                     this.$router.push("/login");
                     
                    //  console.log(response.data.message);
                  } else if(response.data.message.status == false) {
                     this.alert_danger.status = true;
                     this.alert_danger.text =  response.data.message.message;
                    //  console.log(response.data.message);
                  }
                 
              })
              .catch((error) => {
                  console.log(error);
                // this.$router.push("/login");
              });
            // this.$router.push("/login");
            // console.log('สำเร็จ');
            } else {
         
              this.alert_danger.status = true;
              this.alert_danger.text = "รหัสผ่านไม่ตรงกัน";

            }
           
          } else {
            
            this.alert_danger.status = true;
            this.alert_danger.text = "ตรวจพบอักขระพิเศษ";

            // alert('ตรวจพบอักขระพิเศษ')
          }
      } else {
     
        this.alert_danger.status = true;
        this.alert_danger.text = "กรุณากรอกรหัสผ่าน";
      }
    },
    checkpassword: function () {
      // this.has_minimum_lenth = (this.password.length > 8);
    },
  },
};
</script>
<style>
</style>
